import React from 'react';

export const LanIcon = ({ color, ...restProps }: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
            <path
                d="M8.24276 13.8278L13.2525 13.7907L13.2201 9.4072L11.3414 9.4211L11.3229 6.91622L8.19179 6.93939L8.18253 5.68694L10.0612 5.67304L10.0288 1.2895L5.01899 1.32657L5.05142 5.71011L6.93008 5.69621L6.93935 6.94865L3.80825 6.97182L3.82678 9.4767L1.94812 9.4906L1.98055 13.8741L6.99032 13.8371L6.95788 9.45353L5.07922 9.46743L5.06996 8.21499L10.0797 8.17793L10.089 9.43037L8.21033 9.44427L8.24276 13.8278ZM6.2946 4.4484L6.2807 2.56974L8.78558 2.55121L8.79948 4.42987L6.2946 4.4484ZM5.71471 10.7152L5.72861 12.5939L3.22373 12.6124L3.20983 10.7338L5.71471 10.7152ZM11.9769 10.6689L11.9908 12.5476L9.48593 12.5661L9.47203 10.6874L11.9769 10.6689Z"
                fill={color ?? '#717680'}
            />
        </svg>
    );
};
